module.exports = "<div class=\"align-content-center container\">\n    <div class=\"text-center\"><h1>Classification Trend</h1><div>\n    <div class=\"text-center\" style=\"height: 500px;\"><canvas id=\"myTrend\" style=\"height: 100%;\"></canvas></div>\n</div>\n<br>\n<br>\n<div class=\"container-fluid\">\n  <footer class=\"text-center\" >\n    <p>copyrights-2018 by <a href=\"https://ust-global.com\">ust-global.com</a></p>\n    <p>designed by Vamsi and Varun</p>\n  </footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/line-trend/line-trend.component.html
// module id = ./src/app/line-trend/line-trend.component.html
// module chunks = main